import React from 'react'

import 'jquery-mask-plugin/dist/jquery.mask.min'
import CalculadoraModalidades from '../../components/CaluladoraModalidades';

export default function Calculadora() {

    return (
        <div className="content">
            <div className="f-header-content f-header-content--centralizado">
                <h1 className="f-header-content_title"> Simulador das modalidades de inscrição do sisu </h1>
            </div>
            <div className="container-sm card-body text-8vw">
                <CalculadoraModalidades />
            </div>
        </div>
    )
}